// модуль для отображения попапа "Контакты"
import {fetchData} from '@apress/apress-frontend-utils/utils/fetch-data/fetch-data.js';

app.modules.companyContactsPopup = ((self = {}) => {
  let _contentByCompanyId;
  let _companyId;
  let _popup;

  const _getContentPopup = (companyAboutUrl, button) => {
    button.disabled = true;

    fetchData({
      url: companyAboutUrl,
      responseType: 'text',
      isXMLHttp: true,
      onSuccess: (content) => {
        _contentByCompanyId = content;
        _createPopup(_contentByCompanyId);
      },
      onFail: console.error,
    }).finally(() => {
      button.disabled = false;
    });
  };

  const _createPopup = (popupContent) => {
    const container = document.createElement('div');
    container.innerHTML = popupContent;
    _popup = app.modules.modalDialog.create({
      content: container,
      dialogClass: !app.config.isMobile && 'company-contacts__popup',
    });
  };

  const _handleClick = (event) => {
    if (!event.isTrusted) return;

    const target = event.target;

    if (target.closest('.js-close-popup')) {
      _popup.close();
      return;
    }
    const buttonShowCompanyContacts = target.closest(
      '.js-show-company-contacts-popup'
    );

    if (!buttonShowCompanyContacts) return;

    if (_contentByCompanyId && _companyId === target.dataset.companyId) {
      _createPopup(_contentByCompanyId);
      return;
    }

    _getContentPopup(
      target.closest('.js-show-company-contacts-popup').dataset
        .ajaxCompanyAboutUrl,
      buttonShowCompanyContacts
    );
    _companyId = target.dataset.companyId;
  };

  const _addListeners = () => {
    document.addEventListener('click', _handleClick);
  };

  self.load = _addListeners;
  return self;
})(app.modules.companyContactsPopup);
